import styled from "styled-components";
import Modal from "react-modal";

export const StyledReactModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 2rem;
  /* width: 68.5rem; */
  background: white;
  overflow: auto;
  outline: none;

  @media (max-width: 500px) {
    width: 90%;
    padding: 1.5rem;
  }
  @media (max-width: 1200px) {
 
    margin-left: 2rem;

  }
`;
export const Container = styled.form`

h1{
    font-weight: 600;
}


`
